import React, { createContext, useState } from 'react';
import SubscriptionService from 'services/SubscriptionService';

export const OnlinePurchaseContext = createContext();

export default function OnlinePurchaseProvider(props) {
  const [isLoading, setLoading] = useState(false);
  const [subscriptionsAndAddons, setSubscriptionsAndAddons] = useState(null);
  const [purchaseData, setPurchaseData] = useState(() => {
    const savedData = sessionStorage.getItem('purchaseData');
    return savedData
      ? JSON.parse(savedData)
      : {
          subscription: null,
          add_ons: [],
          amount: 0,
          payable: 0,
          tax: 0,
          shop_details: null,
          country: null,
        };
  });

  React.useEffect(() => {
    sessionStorage.setItem('purchaseData', JSON.stringify(purchaseData));
  }, [purchaseData]);

  const loadSubscriptionsAndAddons = async () => {
    if (subscriptionsAndAddons) return;
    setLoading(true);
    try {
      const resp = await SubscriptionService.getSubscriptionsAndAdons();
      setSubscriptionsAndAddons(resp);
    } catch (e) {
      console.error('Failed to load subscriptions', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <OnlinePurchaseContext.Provider
      value={{
        isLoading,
        purchaseData,
        subscriptionsAndAddons,
        setPurchaseData,
        loadSubscriptionsAndAddons,
      }}
    >
      {props.children}
    </OnlinePurchaseContext.Provider>
  );
}
